import ReactDOM from "react-dom/client";
import App from "./App.js";
import "./styles/main.scss";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "./core/services/axios";
import "../src/assets/scss/global.scss";
import "../src/routes/intel/us/company-profile/styles/company-search.scss";
import { Provider } from "react-redux";
import { persistor, store } from "./redux/store.jsx";
import { PersistGate } from "redux-persist/integration/react";
import { AmplitudeAnalyticsProvider, LocalAnalyticsProvider } from "@core/analytics";
import { analyticsConfig } from "./config/analytics.config";

// After a deploy, stale tabs may request chunk hashes that no longer exist; reload once to pick up the new build.
// Skips the reload if one already happened in the last 10s, so a genuinely missing chunk can't cause a reload loop.
window.addEventListener("vite:preloadError", (event) => {
  const key = "vite-preload-reloaded-at";
  try {
    const last = Number(sessionStorage.getItem(key));
    if (last && Date.now() - last < 10000) return;
    sessionStorage.setItem(key, String(Date.now()));
  } catch {
    return;
  }
  event.preventDefault();
  window.location.reload();
});

const AnalyticsProvider = analyticsConfig.amplitude.enabled ? AmplitudeAnalyticsProvider : LocalAnalyticsProvider;

ReactDOM.createRoot(document.getElementById("root")).render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <AnalyticsProvider apiKey={analyticsConfig.amplitude.apiKey}>
        <App />
      </AnalyticsProvider>
    </PersistGate>
  </Provider>
);
